import { AssetfiAssetType } from '@/types/asset-type';

export default function CopySvg({ width, height }: AssetfiAssetType) {
  return (
    <svg width={width} height={height} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.8457 11.8564H1.9707C1.48745 11.8564 1.0957 11.4647 1.0957 10.9814V2.23145C1.0957 1.7482 1.48745 1.35645 1.9707 1.35645H10.7207C11.204 1.35645 11.5957 1.7482 11.5957 2.23145V3.10645M5.4707 15.3564H14.2207C14.704 15.3564 15.0957 14.9647 15.0957 14.4814V5.73145C15.0957 5.2482 14.704 4.85645 14.2207 4.85645H5.4707C4.98745 4.85645 4.5957 5.2482 4.5957 5.73145V14.4814C4.5957 14.9647 4.98745 15.3564 5.4707 15.3564Z"
        stroke="#242424"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}
